import { render } from "./index.vue?vue&type=template&id=5696b389&bindings={}"
import script from "./Theme.js?vue&type=script&lang=js"
export * from "./Theme.js?vue&type=script&lang=js"

import "./Theme.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script